import { css } from 'styled-system/css';

// utils/animations `loadUpLcpSafeStyle(delay)` as a class + `--load-up-delay` (keyframes
// `sh-load-up-no-fade` already in src/app/globals.css).
export const loadUpClass = css({
  animation: 'sh-load-up-no-fade 1s cubic-bezier(.22,.61,.36,1) var(--load-up-delay, 0s) both',
  _motionReduce: { animation: 'none' },
});

/** AllArticles' two bands: full-width background, content held to the 1920px SectionContentWrapper line. */
export const bandContentClass = css({
  maxW: '1920px',
  mx: 'auto',
  pt: 20,
  px: { base: 5, sm: 6, lg: 20, '3xl': 24 },
  pb: { base: 8, sm: 14, md: 8 },
});
